<template>
  <div class="pallet-page">
    <pallet-page-stats style="margin-bottom: 20px;" />
    <common-card v-loading="loadingPallet">
      <searchable-table
        :table-headers="PalletTableHeaders"
        :table-data="palletsPage"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :action-width="120"
        :has-actions="true"
        :has-row-expand="false"
      >
        <template v-slot:actions="props">
          <div class="actions f-r">
            <el-button
              size="small"
              type="text"
              @click="labelPallet(props.row.no)"
            >
              Label
            </el-button>
            <el-button
              size="small"
              type="text"
              class="danger-text"
              @click="modifyPallet(props.row)"
            >
              Modify
            </el-button>
          </div>
        </template>
      </searchable-table>
      <pallet-modify ref="palletModify" />
      <note-edit ref="newNote" />
    </common-card>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import debounce from 'lodash/debounce'

// models
import {
  PalletTableHeaders,
  PalletSearchForm,
  PalletSearchParamsWrapUp
} from '@/core/models/pallet'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// apis
import { modifyPallet, queryPallets, labelPallet } from '@/api/pallet'
import { generatePalletLabels } from '@/core/utils/label'
// import { changeStatus } from '@/api/note'
// components
// import PalletPageStats from '@/components/pallet/PalletPageStats.vue'
import PalletPageStats from '@/views/pallet/PalletPageStats.vue'
import SearchableTable from '@/components/common/SearchableTable.vue'
import CommonCard from '@/components/common/CommonCard.vue'
import PalletModify from '@/components/pallet/PalletModify.vue'
import NoteEdit from '@/components/note/NoteNew.vue'
// msg
import PagesMessage from '@/core/message/pages'
// utils
import { getNoteCreatedTime } from '@/core/utils/note'
import { viewPdf } from '@/core/utils'
import { queryAddress } from '@/api/address'
import { InitSearchForm } from '@/core/configs/types'

export default {
  name: 'PalletPage',
  components: {
    PalletPageStats,
    SearchableTable,
    CommonCard,
    PalletModify,
    NoteEdit
  },
  mixins: [pageJumps],
  data() {
    return {
      PalletTableHeaders,
      palletsPage: null,
      searchForm: InitSearchForm(PalletSearchForm, PalletTableHeaders),
      loadingPallet: true,
      curTab: 'palletTable',
      debouncedQuery: debounce(this.queryPallets, 300)
    }
  },
  mounted() {
    this.debouncedQuery()
    PagesMessage.on(
      PagesMessage.eventMap.REFRESH_PALLET_PAGE,
      this.debouncedQuery
    )
  },
  methods: {
    getNoteCreatedTime,
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.debouncedQuery()
    },
    // changeStatus,
    changeStatus(index, pallet, noteIndex, note, status) {
      // todo passed from outside
      const original = cloneDeep(pallet.notes)
      original[noteIndex].status = status
      modifyPallet(pallet.id, { notes: original }).then(res => {
        if (res) {
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_PALLET_PAGE)
        }
      })
    },
    // apis
    async queryPallets() {
      this.loadingPallet = true
      const pallets = await queryPallets(
        PalletSearchParamsWrapUp(this.searchForm)
      )
      const addressIds = pallets.records.map(one => one.addressId)
      const addressPage = await queryAddress({ addressIds, size: -1 })
      const addressMap = Object.fromEntries(
        addressPage.records.map(one => [one.id, one])
      )
      pallets.records.forEach(one => {
        one.address = addressMap[one.addressId]
      })
      this.$set(this, 'palletsPage', pallets)
      this.loadingPallet = false
    },
    selectTabChange() {},
    generatePalletLabels(pallet) {
      const labelInfo = {
        factoryNo: pallet.deliveryAddress,
        palletNo: pallet.no,
        containerNo: 'SEKU4362799',
        shortContainerNo: '01834'
      }
      generatePalletLabels([labelInfo])
    },
    changeHold(row, index) {
      modifyPallet(row.id, { hold: true }).then(res => {
        if (res) {
          this.$set(
            this.palletList[index],
            'hold',
            !this.palletList[index].hold
          )
        } else {
          this.$$message.error('Change pallet hold status failed!')
        }
      })
    },
    modifyPallet(pallet) {
      this.$refs.palletModify.open(pallet, () => {
        PagesMessage.emit(PagesMessage.eventMap.REFRESH_PALLET_PAGE)
      })
    },
    newPalletNote(index, pallet) {
      const saveNote = newNote => {
        modifyPallet(pallet.id, {
          notes: [...(pallet.notes ?? []), newNote]
        }).then(pallet => {
          this.$set(this.palletList, index, pallet)
        })
      }
      this.$refs.newNote.open(saveNote)
    },
    async labelPallet(palletNo) {
      // download pallet labels
      const blob = await labelPallet(palletNo)
      viewPdf(blob)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';
@import '@/assets/styles/note-list.scss';

.actions {
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px 10px;

  .el-button {
    margin: 0 !important;
  }
}
</style>
